import r2wc from "@r2wc/react-to-web-component";
import { RVSearchContainer } from "../components/RVSearchContainer";

const RVSearchWebComponent = r2wc(RVSearchContainer, {
  props: {
    apiKey: "string",
    fleetId: "string",
    apiBaseUrl: "string",
    searchParams: "json",
    location: "json",
    initialFilters: "json",
    radiusMiles: "number",
    theme: "string",
    primaryColor: "string",
    googleMapsApiKey: "string",
    currency: "string",
    className: "string",
    defaultLogoUrl: "string",
    appBaseUrl: "string",
    onReserve: "function",
    onVehicleSelect: "function",
    onSearch: "function",
    onFiltersChange: "function",
  },
  events: {
    onReserve: { bubbles: true, composed: true },
    onVehicleSelect: { bubbles: true, composed: true },
    onSearch: { bubbles: true, composed: true },
    onFiltersChange: { bubbles: true, composed: true },
  },
});

if (!customElements.get("fm-rv-search")) {
  customElements.define("fm-rv-search", RVSearchWebComponent);
}
